<template>
    <div class="network-invite">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block">
                <form @submit.prevent="submit" method="POST" accept-charset="UTF-8" novalidate="novalidate">
                    <header>
                        <h5>Request Network Access</h5>
                    </header>

                    <div class="row">
                        <div class="col-sm-4 has-feedback"
                             :class="{'has-error': errors.has('NetworkInvite[building]')}">
                            <label for="network-invite-building">Building</label>

                            <select id="network-invite-building"
                                    v-validate="'required'"
                                    v-model="model.building"
                                    name="NetworkInvite[building]"
                                    class="form-control"
                                    aria-required="true">
                                <option value="">-</option>
                                <option v-for="building in buildings" :value="building">
                                    {{building}}
                                </option>
                            </select>

                            <span v-show="errors.has('NetworkInvite[building]')" class="help-block">
                                {{ errors.first('NetworkInvite[building]') }}
                            </span>
                        </div>

                        <div class="col-sm-4 has-feedback"
                             :class="{'has-error': errors.has('NetworkInvite[floor]')}">
                            <label for="network-invite-floor">Floor</label>

                            <select id="network-invite-floor"
                                    v-validate="'required'"
                                    v-model="model.floor"
                                    name="NetworkInvite[floor]"
                                    class="form-control"
                                    :disabled="!model.building"
                                    aria-required="true">
                                <option value="">-</option>
                                <option v-for="floor in floors" :value="floor">
                                    {{floor}}
                                </option>
                            </select>

                            <span v-show="errors.has('NetworkInvite[floor]')" class="help-block">
                                {{ errors.first('NetworkInvite[floor]') }}
                            </span>
                        </div>

                        <div class="col-sm-4 has-feedback"
                             :class="{'has-error': errors.has('NetworkInvite[unit]')}">
                            <label for="network-invite-unit">Unit</label>

                            <select id="network-invite-unit"
                                    v-validate="'required'"
                                    v-model="model.unit"
                                    name="NetworkInvite[unit]"
                                    class="form-control"
                                    :disabled="!model.building || !model.floor"
                                    aria-required="true">
                                <option value="">-</option>
                                <option v-for="unit in units" :value="unit">
                                    {{unit}}
                                </option>
                            </select>

                            <span v-show="errors.has('NetworkInvite[unit]')" class="help-block">
                                {{ errors.first('NetworkInvite[unit]') }}
                            </span>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-xs-4">
                            <button class="btn btn-link" type="button" @click="closeModal">Back</button>
                        </div>
                        <div class="col-xs-8 text-right">
                            <button class="btn btn-success" type="submit" :disabled="loading">
                                Request Access
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            credentialOptions: {
                required: true,
                type: Array,
            },

            modalId: {
                default: Math.random().toString(),
                type: String
            },
        },

        data(){
            return {
                loading: false,

                model: {
                    building: null,
                    floor: null,
                    unit: null,
                },
            };
        },

        computed: {
            buildings(){
                return _.uniq( _.map( this.credentialOptions, 'Building' ) ).sort();
            },

            floors(){
                if( this.model.building ){
                    return _.uniq(
                        _.map(
                            _.filter( this.credentialOptions, ( credentialOption ) => {
                                return credentialOption.Building === this.model.building;
                            } ),
                            'Floor'
                        )
                    ).sort();
                }

                return [];
            },

            units(){
                if( this.model.building && this.model.floor ){
                    return _.uniq(
                        _.map(
                            _.filter( this.credentialOptions, ( credentialOption ) => {
                                return credentialOption.Building === this.model.building &&
                                    credentialOption.Floor === this.model.floor;
                            } ),
                            'Unit'
                        )
                    ).sort();
                }

                return [];
            },

            form(){
                var form = document.createElement( 'form' );
                form.setAttribute( 'method', 'POST' );
                form.setAttribute( 'action', '/networkInvite' );

                var hiddenField = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', '_method' );
                hiddenField.setAttribute( 'value', 'POST' );

                var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );

                form.appendChild( tokenField );
                form.appendChild( hiddenField );

                _.forIn( this.model, ( value, key ) => {
                    if( value !== null ){
                        let field = document.createElement( 'input' );
                        field.setAttribute( 'type', 'hidden' );
                        field.setAttribute( 'name', 'NetworkInvite[' + key + ']' );
                        field.setAttribute( 'value', value );
                        form.appendChild( field );
                    }
                } );

                return form;
            },
        },

        methods: {
            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            },

            submit(){
                return this.$validator.validateAll()
                    .then( ( valid ) => {

                        if( valid ){
                            this.loading = true;

                            document.body.appendChild( this.form );
                            this.form.submit();
                        }
                    } );
            }
        }
    }
</script>